import React from "react";
import { Route } from "react-router-dom";

import { IAuthUser } from "../interfaces/IAuthUser";
import { ExhibitionEvaluation } from "../pages/exhibitionEvaluation/ExhibitionEvaluation";
import { ExhibitionsJudges } from "../pages/exhibitionsJudges/ExhibitionsJudges";

interface JudgeRoutesProps {
  user: IAuthUser | null;
}

export const JudgeRoutes: React.FC<JudgeRoutesProps> = ({ user }) => {
  if (!user || user.typeId !== 2) return null;

  return (
    <>
      <Route
        path="/exhibitions"
        element={<ExhibitionsJudges pageTitle="Julgamento | Exposições" />}
      />
      <Route
        path="/exhibition-evaluation/:id"
        element={<ExhibitionEvaluation pageTitle="Julgamento" />}
      />
    </>
  );
};
